module.exports = __webpack_public_path__ + "static/media/event-services-img10.637631d9.jpg";